var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    { staticClass: "px-3 pb-3", attrs: { color: "transparent" } },
    [
      _c(
        "v-container",
        { staticClass: "pa-0 ma-0 fill-height", attrs: { fluid: "" } },
        [
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  _vm.hideAttachmentOverlay(),
                    _vm.$root.$emit("attachmentIsClosed")
                },
              },
            },
            [
              _c(
                "v-overlay",
                {
                  attrs: { "z-index": "203", value: _vm.viewAttachmentOverlay },
                },
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "center" } },
                    [_c("v-img", { attrs: { src: _vm.attachment } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "fill-height",
              attrs: { justify: "start", align: "stretch" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex flex-column pa-0 ma-0",
                  attrs: { color: "transparent", cols: "12", md: "8" },
                },
                [_c("WorkTimeAccount", { staticClass: "flex-grow-1" })],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "d-flex flex-column pa-0 ma-0 pl-3",
                  attrs: { color: "transparent", cols: "12", md: "4" },
                },
                [
                  _c("MiniPublicHolidays", { staticClass: "mb-3 flex-grow-1" }),
                  _c("MiniAbsenceAdministration", {
                    staticClass: "flex-grow-1",
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }